import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink} from '@angular/router';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { AboutMenuComponent } from '../../shared/about-menu/about-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';

@Component({
  selector: 'app-faqs',
  standalone: true,
  imports: [CommonModule, RouterLink, MainMenuComponent, AboutMenuComponent, SubscribeComponent],
  templateUrl: '../templates/faqs.component.html'
})
export class FaqsComponent implements AfterViewInit, OnDestroy {
  constructor(private readonly scriptLoader: ScriptLoaderService) { }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }
}

